import { render } from "./FosResXtreme.vue?vue&type=template&id=6bd0231d&scoped=true"
import script from "./FosResXtreme.vue?vue&type=script&lang=js"
export * from "./FosResXtreme.vue?vue&type=script&lang=js"

import "./FosResXtreme.vue?vue&type=style&index=0&id=6bd0231d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd0231d"]])

export default __exports__